import React, { useState, useEffect } from 'react';
import { Card, Button, Badge, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faUsers, faFire } from '@fortawesome/free-solid-svg-icons';
import ProgrammingService from './programming/ProgrammingService';
import { useNavigate } from 'react-router-dom';
const TodaysWorkoutCard = ({ workout }) => {
  const [timeToClass, setTimeToClass] = useState('');
  const navigate = useNavigate();
  useEffect(() => {
    const calculateTimeToClass = () => {
      const classTime = new Date(workout.classTime);
      const classEndTime = workout.endTime
        ? new Date(`${workout.date}T${workout.endTime}`)
        : null;
      const now = new Date();
      const diff = classTime - now;

      if (diff <= 0) {
        // Class has already started, check if it has also finished
        if (classEndTime && now >= classEndTime) {
          return 'Class finished';
        }
        return 'Class in progress';
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

      if (hours > 0) {
        return `${hours}h ${minutes}m`;
      }
      return `${minutes}m`;
    };

    setTimeToClass(calculateTimeToClass());

    const interval = setInterval(() => {
      setTimeToClass(calculateTimeToClass());
    }, 60000);

    return () => clearInterval(interval);
  }, [workout.classTime, workout.endTime, workout.date]);


  const classTime = new Date(workout.classTime);
  const formattedTime = classTime.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit'
  });

  return (
    <Card className="h-100 bg-dark text-white border-0 shadow-sm overflow-hidden position-relative wod-dark-card">
      <div
        className="position-absolute top-0 start-0 w-100 h-100 opacity-10"
        style={{
          background: 'linear-gradient(135deg, #FF6B35 0%, #FCBE0E 100%)'
        }}
      />
      <Card.Body className="position-relative">
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <Badge bg="danger" className="mb-2">
              {workout.type}
            </Badge>
            <h3 className="text-white fw-bold mb-0">{workout.title}</h3>
          </div>
          <div className="text-end">
            <div className="fs-3 fw-bold text-warning text-white">{timeToClass}</div>
            <small className="text-white fs-1">to class</small>
          </div>
        </div>
        <div
          className="text-white-75 mb-4 overflow-auto"
          style={{ height: '150px' }}
          dangerouslySetInnerHTML={{ __html: workout.description }}
        />

        <Row className="g-3 mb-4">
          <Col xs={6}>
            <div className="d-flex align-items-center">
              <FontAwesomeIcon icon={faClock} className="text-warning me-2" />
              <div>
                <small className="text-white-50 d-block">Time</small>
                <strong className="text-white">{formattedTime}</strong>
              </div>
            </div>
          </Col>
          <Col xs={6}>
            <div className="d-flex align-items-center">
              <FontAwesomeIcon icon={faUsers} className="text-warning me-2" />
              <div>
                <small className="text-white-50 d-block">Spots Left</small>
                <strong className="text-white">
                  {workout.spotsLeft}/{workout.totalSpots}
                </strong>
              </div>
            </div>
          </Col>
        </Row>

        <div className="mb-3">
          <small className="text-white-50 d-block mb-1">Coach</small>
          <div className="d-flex align-items-center">
            <div
              className="rounded-circle bg-warning d-flex align-items-center justify-content-center me-2"
              style={{ width: '32px', height: '32px' }}
            >
              <FontAwesomeIcon icon={faFire} className="text-dark" />
            </div>
            <strong className="text-white">{workout.coach}</strong>
          </div>
        </div>

        <div className="d-flex gap-2">
          {workout.status === 'booked' ? (
            <>
              <Button variant="warning" className="flex-grow-1 fw-semibold" onClick={()=>{navigate('/app/wod/programming')}}>
                View WOD Details
              </Button>
              <Button variant="outline-light" className="flex-grow-1" onClick={()=> navigate('/app/wod/timetable')}>
                Cancel Booking
              </Button>
            </>
          ) : (
            <Button variant="warning" className="w-100 fw-semibold" onClick={()=> navigate('/app/wod/timetable')}>
              Book Next Class
            </Button>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default TodaysWorkoutCard;
